import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  QueryFormColumn,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { RGBAColor } from '../../types';


export type EchartsGaugeFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric?: string;
    showLabels: boolean;
    rowLimit: number;
    gradeColor1: RGBAColor;
    gradeColor2: RGBAColor;
    gradeColor3: RGBAColor;
    gradeColor4: RGBAColor;
    gradeLabel1: string;
    gradeLabel2: string;
    gradeLabel3: string;
    gradeLabel4: string;
    threshold2: string;
    threshold3: string;
    threshold4: string;
    rangeMin: string;
    rangeMax: string;
};

export interface EchartsGaugeChartProps
  extends ChartProps<EchartsGaugeFormData> {
  formData: EchartsGaugeFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsGaugeFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  rowLimit: 10,
  gradeColor1: { r: 124, g: 255, b: 178, a: 1 },
  gradeColor2: { r: 88, g: 217, b: 249, a: 1 },
  gradeColor3: { r: 253, g: 221, b: 96, a: 1 },
  gradeColor4: { r: 255, g: 110, b: 118, a: 1 },
  gradeLabel1: 'Grade A',
  gradeLabel2: 'Grade B',
  gradeLabel3: 'Grade C',
  gradeLabel4: 'Grade D',
  threshold2: '25',
  threshold3: '50',
  threshold4: '75',
  rangeMin: '0',
  rangeMax: '100'
};

export interface GaugeChartTransformedProps {
  formData: EchartsGaugeFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  // labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}